import { Link } from 'react-router-dom';
import { associationServices } from '@/mocks/associationData';
import { useTranslation } from 'react-i18next';

export default function AssociationServices() {
  const { t } = useTranslation();
  const serviceKeys = [
    { title: 'association.services.1.title', desc: 'association.services.1.desc', icon: associationServices[0].icon, href: associationServices[0].href },
    { title: 'association.services.2.title', desc: 'association.services.2.desc', icon: associationServices[1].icon, href: associationServices[1].href },
    { title: 'association.services.3.title', desc: 'association.services.3.desc', icon: associationServices[2].icon, href: associationServices[2].href },
    { title: 'association.services.4.title', desc: 'association.services.4.desc', icon: associationServices[3].icon, href: associationServices[3].href },
  ];

  return (
    <section className="relative py-20 md:py-28 bg-background-100/50">
      <div className="max-w-[1600px] mx-auto px-8 md:px-12 lg:px-16">
        <div className="text-center mb-14">
          <p className="text-accent-600 text-[13px] tracking-[0.2em] mb-5 font-label">
            WHAT WE OFFER
          </p>
          <h2 className="font-heading text-xl md:text-2xl text-foreground-900 tracking-[0.06em] mb-2">
            {t('association.services.title')}
          </h2>
          {String(t('association.services.subtitleEn')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="section-title-en text-accent-500 text-[15px] tracking-[0.12em] mb-4">{__s}</p>))}
          <div className="gold-line mx-auto mb-6"></div>
          {String(t('association.services.lead')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="text-[16px] text-foreground-600 tracking-[0.04em] leading-relaxed max-w-[650px] mx-auto">{__s}</p>))}
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
          {serviceKeys.map((service, idx) => (
            <Link
              key={idx}
              to={service.href}
              className="card-glow group block bg-background-50 border border-background-200/60 p-6 md:p-7 cursor-pointer"
            >
              <div className="w-12 h-12 rounded-full bg-accent-500/8 border border-accent-500/20 flex items-center justify-center mb-5">
                <i className={`${service.icon} text-accent-500 text-xl`}></i>
              </div>
              <h3 className="font-heading text-[17px] text-foreground-900 tracking-[0.06em] mb-3 group-hover:text-accent-600 transition-colors">
                {t(service.title)}
              </h3>
              {String(t(service.desc)).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="text-[15px] text-foreground-500 tracking-[0.04em] leading-relaxed mb-4">{__s}</p>))}
              <div className="flex items-center gap-2 text-accent-500 group-hover:text-accent-400 transition-colors">
                <span className="text-[13px] tracking-[0.06em]">{t('association.services.viewLink')}</span>
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-arrow-right-line text-xs"></i>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
